import React, { useEffect, useRef, useState } from "react";
import { MeetingDetailsScreen } from "../MeetingDetailsScreen";
import { createMeeting, getToken, validateMeeting } from "../../api";
import ConfirmBox from "../ConfirmBox";
// Removed video icons
import MicOffIcon from "../../icons/MicOffIcon";
import MicOnIcon from "../../icons/Bottombar/MicOnIcon";
import request from "../../config/request";
import { toast } from "react-toastify";
import { Constants, useMediaDevice } from "@videosdk.live/react-sdk";
import MicPermissionDenied from "../../icons/MicPermissionDenied";
import NetworkStats from "../NetworkStats";
import DropDownSpeaker from "../DropDownSpeaker";
import DropDown from "../DropDown";
import useMediaStream from "../../hooks/useMediaStream";
import useIsMobile from "../../hooks/useIsMobile";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import { useUserAuth } from "../../hooks/UserAuthContext";
import {
  MicrophoneIcon,
  SpeakerWaveIcon,
  UserIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  CogIcon,
  SignalIcon
} from "@heroicons/react/24/outline";

export function JoiningScreen({
  participantName,
  setParticipantName,
  setMeetingId,
  setToken,
  setMicOn,
  onClickStartMeeting,
  customAudioStream,
  setCustomAudioStream,
  micOn,
}) {
  const {
    selectedMic,
    setSelectedMic,
    isMicrophonePermissionAllowed,
    setIsMicrophonePermissionAllowed,
  } = useMeetingAppContext()

  const isMobile = useIsMobile();

  const [{ mics, speakers }, setDevices] = useState({
    mics: [],
    speakers: [],
  });
  const { getAudioTrack } = useMediaStream();
  const {
    checkPermissions,
    getMicrophones,
    requestPermission,
    getPlaybackDevices,
  } = useMediaDevice({ onDeviceChanged });
  const [audioTrack, setAudioTrack] = useState(null);
  const [dlgMuted, setDlgMuted] = useState(false);
  const [dlgDevices, setDlgDevices] = useState(false);
  const [didDeviceChange, setDidDeviceChange] = useState(false);
  const [testSpeaker, setTestSpeaker] = useState(false);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [showMicAlert, setShowMicAlert] = useState(false);
  const [showSpeakerAlert, setShowSpeakerAlert] = useState(false);
  const [showPermissionAlert, setShowPermissionAlert] = useState(false);
  const { user, fetchBookingDetails, isLoading, setBookingDetails } = useUserAuth();

  const audioPlayerRef = useRef();
  const audioTrackRef = useRef();
  const audioAnalyserIntervalRef = useRef();
  const permissonAvaialble = useRef();
  const micRef = useRef();

  useEffect(() => {
    micRef.current = micOn;
  }, [micOn]);

  useEffect(() => {
    permissonAvaialble.current = {
      isMicrophonePermissionAllowed,
    };
  }, [isMicrophonePermissionAllowed]);

  useEffect(() => {
    if (micOn) {
      audioTrackRef.current = audioTrack;
      startMuteListener();
    }
  }, [micOn, audioTrack]);

  useEffect(() => {
    if (micOn) {
      // Close the existing audio track if there's a new one
      if (audioTrackRef.current && audioTrackRef.current !== audioTrack) {
        audioTrackRef.current.stop();
      }

      audioTrackRef.current = audioTrack;

      if (audioTrack) {
        const audioSrcObject = new MediaStream([audioTrack]);
        if (audioPlayerRef.current) {
          audioPlayerRef.current.srcObject = audioSrcObject;
          audioPlayerRef.current
            .play()
            .catch((error) => console.log("audio play error", error));
        }
      } else {
        if (audioPlayerRef.current) {
          audioPlayerRef.current.srcObject = null;
        }
      }
    }
  }, [micOn, audioTrack]);

  useEffect(() => {
    getAudioDevices();
  }, [isMicrophonePermissionAllowed]);

  useEffect(() => {
    checkMediaPermission();
    return () => { };
  }, []);


  const _toggleMic = () => {
    const audioTrack = audioTrackRef.current;

    if (micOn) {
      if (audioTrack) {
        audioTrack.stop();
        setAudioTrack(null);
        setCustomAudioStream(null);
        setMicOn(false);
      }
    } else {
      getDefaultMediaTracks({ mic: true });
      setMicOn(true);
    }
  };

  const changeMic = async (deviceId) => {
    if (micOn) {
      const currentAudioTrack = audioTrackRef.current;
      currentAudioTrack && currentAudioTrack.stop();
      const stream = await getAudioTrack({
        micId: deviceId,
      });
      setCustomAudioStream(stream);
      const audioTracks = stream?.getAudioTracks();
      const audioTrack = audioTracks.length ? audioTracks[0] : null;
      clearInterval(audioAnalyserIntervalRef.current);
      setAudioTrack(audioTrack);
    }
  };

  const getDefaultMediaTracks = async ({ mic }) => {
    if (mic) {
      const stream = await getAudioTrack({
        micId: selectedMic.id,
      });
      setCustomAudioStream(stream);
      const audioTracks = stream?.getAudioTracks();
      const audioTrack = audioTracks?.length ? audioTracks[0] : null;
      setAudioTrack(audioTrack);
    }
  };

  async function startMuteListener() {
    const currentAudioTrack = audioTrackRef.current;
    if (currentAudioTrack) {
      if (currentAudioTrack.muted) {
        setDlgMuted(true);
      }
      currentAudioTrack.addEventListener("mute", (ev) => {
        setDlgMuted(true);
      });
    }
  }

  async function requestAudioPermission(mediaType) {
    try {
      const permission = await requestPermission(mediaType);
      if (mediaType === Constants.permission.AUDIO) {
        const isAudioAllowed = permission.get(Constants.permission.AUDIO);
        setIsMicrophonePermissionAllowed(isAudioAllowed);
        if (isAudioAllowed) {
          setMicOn(true);
          await getDefaultMediaTracks({ mic: true });
        }
      }
    } catch (ex) {
      console.log("Error in requestPermission ", ex);
    }
  }

  function onDeviceChanged() {
    setDidDeviceChange(true);
    getAudioDevices();
    getDefaultMediaTracks({ mic: micRef.current });
  }

  const checkMediaPermission = async () => {
    try {
      const checkAudioPermission = await checkPermissions();
      const microphonePermissionAllowed = checkAudioPermission.get(
        Constants.permission.AUDIO
      );
      setIsMicrophonePermissionAllowed(microphonePermissionAllowed);
      if (microphonePermissionAllowed) {
        setMicOn(true);
        getDefaultMediaTracks({ mic: true });
      } else {
        await requestAudioPermission(Constants.permission.AUDIO);
      }
    } catch (error) {
      await requestAudioPermission(Constants.permission.AUDIO);
      console.log(error);
    }
  };


  const getAudioDevices = async () => {
    try {
      if (permissonAvaialble.current?.isMicrophonePermissionAllowed) {
        let mics = await getMicrophones();
        let speakers = await getPlaybackDevices();
        const hasMic = mics.length > 0;
        if (hasMic) {
          startMuteListener();
        }
        await setSelectedMic({ id: mics[0]?.deviceId, label: mics[0]?.label });
        if (speakers.length > 0) {
          setSelectedSpeaker({ id: speakers[0]?.deviceId, label: speakers[0]?.label });
        }
        setDevices((devices) => {
          return { ...devices, mics, speakers };
        });
      }
    } catch (err) {
      console.log("Error in getting audio devices", err);
    }
  };

  useEffect(() => {
    getAudioDevices()
  }, [])

  const ModernButton = ({ onClick, onState, OnIcon, OffIcon, disabled = false }) => {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        className={`
          relative group rounded-2xl w-14 h-14 flex items-center justify-center 
          transition-all duration-300 ease-in-out transform hover:scale-105 
          focus:outline-none focus:ring-4 focus:ring-offset-2 
          ${onState
            ? "bg-gradient-to-br from-green-400 to-emerald-500 text-white shadow-lg shadow-green-500/25 focus:ring-green-300"
            : "bg-gradient-to-br from-red-400 to-red-500 text-white shadow-lg shadow-red-500/25 focus:ring-red-300"
          }
          ${disabled ? "opacity-50 cursor-not-allowed" : "hover:shadow-xl"}
        `}
      >
        <div className="relative z-10">
          {onState ? (
            <OnIcon className="w-6 h-6" />
          ) : (
            <OffIcon className="w-6 h-6" />
          )}
        </div>

        {/* Ripple effect */}
        <div className="absolute inset-0 rounded-2xl bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {/* Status indicator */}
        <div className={`
          absolute -top-1 -right-1 w-4 h-4 rounded-full border-2 border-white
          ${onState ? "bg-green-400" : "bg-red-400"}
        `}></div>
      </button>
    );
  };

  const SettingsCard = ({ icon: Icon, title, children, status, statusColor = "gray" }) => {
    const statusColors = {
      green: "text-green-600 bg-green-50",
      red: "text-red-600 bg-red-50",
      yellow: "text-yellow-600 bg-yellow-50",
      gray: "text-gray-600 bg-gray-50"
    };

    return (
      <div className="bg-white rounded-2xl hover:shadow-md transition-all duration-300">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center">
                <Icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            </div>
            {status && (
              <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusColors[statusColor]}`}>
                {status}
              </span>
            )}
          </div>
          <div className="space-y-3">
            {children}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-violet-50">
      {/* Header */}
      <div className="">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
                Join Meeting
              </h1>
              <p className="text-gray-600 mt-2 text-lg">Set up your audio and join the session</p>
            </div>
            {user && (
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center shadow-lg">
                  <UserIcon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-base font-semibold text-gray-900">{user.name}</p>
                  <p className="text-sm text-violet-600 font-medium">Ready to join</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main Content - Bento Grid Layout */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-6 auto-rows-max">

          {/* First Row: Ready to Join, Audio Settings, Speaker Settings, Microphone, Network */}
          
          {/* Join Meeting Card - Wide */}
          <div className="md:col-span-2 lg:col-span-2 xl:col-span-4">
            <div className="h-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-3xl p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="flex flex-col h-full">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 mx-auto rounded-3xl bg-white/20 flex items-center justify-center mb-4 backdrop-blur-sm">
                    <MicrophoneIcon className="w-8 h-8 text-white" />
                  </div>
                  <h2 className="text-xl font-bold mb-2">Ready to Join?</h2>
                  <p className="text-white/80">Enter your booking ID</p>
                </div>
                
                <div className="flex-1">
                  <div className="">
                    <MeetingDetailsScreen
                      participantName={participantName}
                      setParticipantName={setParticipantName}
                      onClickJoin={async (id) => {
                        // Validate mandatory audio selections with alerts
                        if (!selectedMic || !selectedMic.id) {
                          setShowMicAlert(true);
                          return;
                        }

                        if (!selectedSpeaker || !selectedSpeaker.id) {
                          setShowSpeakerAlert(true);
                          return;
                        }

                        if (!isMicrophonePermissionAllowed) {
                          setShowPermissionAlert(true);
                          return;
                        }

                        const token = await getToken();
                        let details;
                        try {
                          details = await fetchBookingDetails(id);
                        }
                        catch (e) {
                          console.log("Error in fetching booking details", e);
                          toast.error("Failed to fetch booking details", {
                            position: "bottom-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }

                        console.log(details, "booking details");

                        if (!details) {
                          toast.error("No booking found with this ID", {
                            position: "bottom-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }

                        setBookingDetails(details);

                        if (user.role == "user") {
                          if (details.isUserJoined) {
                            toast.info("User already joined. Duplicate Session Not Allowed", {
                              position: "bottom-right",
                              autoClose: 3000,
                            });
                            return;
                          }
                          else {
                            try {
                              await request.patch(`/api/bookings/user/join/${details.bookingId}`);
                              const { meetingId, err } = await validateMeeting({
                                roomId: details.sessionLink,
                                token,
                              });
                              if (meetingId === details.sessionLink) {
                                setToken(token);
                                setMeetingId(details.sessionLink);
                                onClickStartMeeting();
                              } else {
                                toast.error(`Meeting validation failed: ${err}`, {
                                  position: "bottom-right",
                                  autoClose: 4000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                });
                              }
                              return;
                            } catch (err) {
                              console.log("Error in marking user as joined", err);
                              toast.error("Failed to join the meeting. Please try again.", {
                                position: "bottom-right",
                                autoClose: 4000,
                              });
                              return;
                            }
                          }
                        }
                        else if (user.role == "mentor") {
                          if (details.isMentorJoined) {
                            toast.info("User already joined. Duplicate Session Not Allowed", {
                              position: "bottom-right",
                              autoClose: 3000,
                            });
                            return;
                          } else {
                            try {
                              await request.patch(`/api/bookings/mentor/join/${details.bookingId}`);
                              const { meetingId, err } = await validateMeeting({
                                roomId: details.sessionLink,
                                token,
                              });
                              if (meetingId === details.sessionLink) {
                                setToken(token);
                                setMeetingId(details.sessionLink);
                                onClickStartMeeting();
                              } else {
                                toast.error(`Meeting validation failed: ${err}`, {
                                  position: "bottom-right",
                                  autoClose: 4000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                });
                              }
                              return;
                            } catch (err) {
                              console.log("Error in marking mentor as joined", err);
                              toast.error("Failed to join the meeting. Please try again.", {
                                position: "bottom-right",
                                autoClose: 4000,
                              });
                              return;
                            }
                          }
                        }
                        else {
                          toast.error("Invalid user role", {
                            position: "bottom-right",
                            autoClose: 4000,
                          });
                          return;
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Audio Settings & Mic Column */}
          <div className="md:col-span-1 lg:col-span-1 xl:col-span-2">
            <div className="space-y-4 h-full">
              {/* Audio Settings */}
              <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-white/20">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-orange-400 to-red-500 flex items-center justify-center">
                    <CogIcon className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="text-sm font-bold text-gray-900">Audio Settings</h3>
                </div>
                <div className="bg-gradient-to-r from-violet-50 to-purple-50 rounded-xl p-2 relative overflow-visible">
                  <DropDown
                    mics={mics}
                    changeMic={changeMic}
                    customAudioStream={customAudioStream}
                    audioTrack={audioTrack}
                    micOn={micOn}
                    didDeviceChange={didDeviceChange}
                    setDidDeviceChange={setDidDeviceChange}
                    testSpeaker={testSpeaker}
                    setTestSpeaker={setTestSpeaker}
                  />
                </div>
                {!selectedMic && (
                  <div className="mt-2 text-xs text-red-600 font-medium flex items-center space-x-1">
                    <ExclamationTriangleIcon className="w-3 h-3" />
                    <span>Microphone selection required</span>
                  </div>
                )}
              </div>

              {/* Microphone Control */}
              <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-white/20">
                <div className="flex flex-col items-center space-y-3">
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center">
                      <MicrophoneIcon className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="text-sm font-bold text-gray-900">Mic</h3>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${micOn ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                    {micOn ? "ON" : "OFF"}
                  </span>
                  <div className="flex items-center justify-center">
                    {isMicrophonePermissionAllowed ? (
                      <ModernButton
                        onClick={_toggleMic}
                        onState={micOn}
                        OnIcon={() => <MicrophoneIcon className="w-6 h-6" />}
                        OffIcon={() => <MicrophoneIcon className="w-6 h-6" />}
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-2xl bg-gray-200 flex items-center justify-center">
                        <MicPermissionDenied />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Speaker Settings & Network Column */}
          <div className="md:col-span-1 lg:col-span-1 xl:col-span-2">
            <div className="space-y-4 h-full">
              {/* Speaker Settings */}
              <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-white/20">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-pink-400 to-rose-500 flex items-center justify-center">
                    <SpeakerWaveIcon className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="text-sm font-bold text-gray-900">Speaker Settings</h3>
                </div>
                <div className="bg-gradient-to-r from-violet-50 to-purple-50 rounded-xl p-2 relative overflow-visible">
                  <DropDownSpeaker 
                    speakers={speakers} 
                    selectedSpeaker={selectedSpeaker}
                    setSelectedSpeaker={setSelectedSpeaker}
                  />
                </div>
                {!selectedSpeaker && (
                  <div className="mt-2 text-xs text-red-600 font-medium flex items-center space-x-1">
                    <ExclamationTriangleIcon className="w-3 h-3" />
                    <span>Speaker selection required</span>
                  </div>
                )}
              </div>

              {/* Network Status */}
              <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-white/20">
                <div className="flex flex-col items-center space-y-3">
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-400 to-cyan-500 flex items-center justify-center">
                      <SignalIcon className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="text-sm font-bold text-gray-900">Network</h3>
                  </div>
                  <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-2 w-full">
                    <NetworkStats />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Row: Participant Information and Quick Tips */}
          
          {/* User Profile Card */}
          <div className="md:col-span-2 lg:col-span-2 xl:col-span-4 overflow-hidden">
            <div className="bg-gradient-to-br from-violet-500 to-purple-600 rounded-3xl p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                    <UserIcon className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Participant Information</h3>
                    <div className="bg-white/10 rounded-xl p-3 backdrop-blur-sm overflow-hidden">
                      <p className="text-sm opacity-80 mb-1">User ID</p>
                      <p className="font-semibold text-lg">{participantName}</p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end space-y-2">
                  <span className="bg-green-400/20 text-green-100 px-3 py-1 rounded-full text-sm font-medium">
                    Verified
                  </span>
                  <CheckCircleIcon className="w-6 h-6 text-green-300" />
                </div>
              </div>
            </div>
          </div>

          {/* Quick Tips Card */}
          <div className="md:col-span-2 lg:col-span-2 xl:col-span-4">
            <div className="bg-gradient-to-br from-cyan-400 to-blue-500 rounded-3xl p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                  <CheckCircleIcon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold">Quick Tips</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 rounded-full bg-white/60"></div>
                  <span className="text-white/90">Test your microphone before joining</span>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 rounded-full bg-white/60"></div>
                  <span className="text-white/90">Ensure stable internet connection</span>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="w-2 h-2 rounded-full bg-white/60"></div>
                  <span className="text-white/90">Have your booking ID ready</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>

      {/* Dialogs */}
      <ConfirmBox
        open={dlgMuted}
        variant="warning"
        title="System microphone is muted"
        subTitle="Your default microphone is muted. Please unmute it or increase audio input volume from system settings."
        successText="Got it"
        onSuccess={() => setDlgMuted(false)}
        size="md"
      />

      <ConfirmBox
        open={dlgDevices}
        variant="info"
        title="Microphone not available"
        subTitle="Please connect a microphone to speak in the meeting. You can also join without it."
        successText="Dismiss"
        onSuccess={() => setDlgDevices(false)}
        size="md"
      />

      {/* Audio Selection Alerts */}
      <ConfirmBox
        open={showMicAlert}
        variant="warning"
        title="Microphone Required"
        subTitle="Please select a microphone from the Audio Settings before joining the meeting. This is required for communication during the session."
        successText="OK, I'll select one"
        onSuccess={() => setShowMicAlert(false)}
        size="md"
      />

      <ConfirmBox
        open={showSpeakerAlert}
        variant="warning"
        title="Speaker Required"
        subTitle="Please select a speaker from the Speaker Settings before joining the meeting. This is required to hear audio during the session."
        successText="OK, I'll select one"
        onSuccess={() => setShowSpeakerAlert(false)}
        size="md"
      />

      <ConfirmBox
        open={showPermissionAlert}
        variant="error"
        title="Microphone Permission Required"
        subTitle="Please allow microphone access in your browser settings and refresh the page. Microphone permission is mandatory for joining meetings."
        successText="I understand"
        onSuccess={() => setShowPermissionAlert(false)}
        size="md"
      />

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-sm w-full mx-4">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600 mx-auto mb-4"></div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Loading...</h3>
              <p className="text-gray-600">Please wait while we set up your session</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
